module.exports = __webpack_public_path__ + "media/images/cleaning/karima@3x-47c8073905259b66757bdd401105f8d2.jpg";